import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=6c8e4c9a&scoped=true&"
import script from "./Index.vue?vue&type=script&lang=ts&"
export * from "./Index.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8e4c9a",
  null
  
)

export default component.exports